const ICONS = {
  google: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width="100"
      height="100"
      viewBox="0 0 48 48"
      className="size-5"
    >
      <rect
        width="22"
        height="22"
        x="13"
        y="13"
        fill="#fff"
      ></rect>
      <polygon
        fill="#1e88e5"
        points="25.68,20.92 26.688,22.36 28.272,21.208 28.272,29.56 30,29.56 30,18.616 28.56,18.616"
      ></polygon>
      <path
        fill="#1e88e5"
        d="M22.943,23.745c0.625-0.574,1.013-1.37,1.013-2.249c0-1.747-1.533-3.168-3.417-3.168 c-1.602,0-2.972,1.009-3.33,2.453l1.657,0.421c0.165-0.664,0.868-1.146,1.673-1.146c0.942,0,1.709,0.646,1.709,1.44 c0,0.794-0.767,1.44-1.709,1.44h-0.997v1.728h0.997c1.081,0,1.993,0.751,1.993,1.64c0,0.904-0.866,1.64-1.931,1.64 c-0.962,0-1.784-0.61-1.914-1.418L17,26.802c0.262,1.636,1.81,2.87,3.6,2.87c2.007,0,3.64-1.511,3.64-3.368 C24.24,25.281,23.736,24.363,22.943,23.745z"
      ></path>
      <polygon
        fill="#fbc02d"
        points="34,42 14,42 13,38 14,34 34,34 35,38"
      ></polygon>
      <polygon
        fill="#4caf50"
        points="38,35 42,34 42,14 38,13 34,14 34,34"
      ></polygon>
      <path
        fill="#1e88e5"
        d="M34,14l1-4l-1-4H9C7.343,6,6,7.343,6,9v25l4,1l4-1V14H34z"
      ></path>
      <polygon
        fill="#e53935"
        points="34,34 34,42 42,34"
      ></polygon>
      <path
        fill="#1565c0"
        d="M39,6h-5v8h8V9C42,7.343,40.657,6,39,6z"
      ></path>
      <path
        fill="#1565c0"
        d="M9,42h5v-8H6v5C6,40.657,7.343,42,9,42z"
      ></path>
    </svg>
  ),
  outlook: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width="100"
      height="100"
      viewBox="0 0 48 48"
      className="size-5"
    >
      <path
        fill="#1976d2"
        d="M28,13h14.533C43.343,13,44,13.657,44,14.467v19.066C44,34.343,43.343,35,42.533,35H28V13z"
      ></path>
      <rect
        width="14"
        height="15.542"
        x="28"
        y="17.958"
        fill="#fff"
      ></rect>
      <polygon
        fill="#1976d2"
        points="27,44 4,39.5 4,8.5 27,4"
      ></polygon>
      <path
        fill="#fff"
        d="M15.25,16.5c-3.176,0-5.75,3.358-5.75,7.5s2.574,7.5,5.75,7.5S21,28.142,21,24	S18.426,16.5,15.25,16.5z M15,28.5c-1.657,0-3-2.015-3-4.5s1.343-4.5,3-4.5s3,2.015,3,4.5S16.657,28.5,15,28.5z"
      ></path>
      <rect
        width="2.7"
        height="2.9"
        x="28.047"
        y="29.737"
        fill="#1976d2"
      ></rect>
      <rect
        width="2.7"
        height="2.9"
        x="31.448"
        y="29.737"
        fill="#1976d2"
      ></rect>
      <rect
        width="2.7"
        height="2.9"
        x="34.849"
        y="29.737"
        fill="#1976d2"
      ></rect>
      <rect
        width="2.7"
        height="2.9"
        x="28.047"
        y="26.159"
        fill="#1976d2"
      ></rect>
      <rect
        width="2.7"
        height="2.9"
        x="31.448"
        y="26.159"
        fill="#1976d2"
      ></rect>
      <rect
        width="2.7"
        height="2.9"
        x="34.849"
        y="26.159"
        fill="#1976d2"
      ></rect>
      <rect
        width="2.7"
        height="2.9"
        x="38.25"
        y="26.159"
        fill="#1976d2"
      ></rect>
      <rect
        width="2.7"
        height="2.9"
        x="28.047"
        y="22.706"
        fill="#1976d2"
      ></rect>
      <rect
        width="2.7"
        height="2.9"
        x="31.448"
        y="22.706"
        fill="#1976d2"
      ></rect>
      <rect
        width="2.7"
        height="2.9"
        x="34.849"
        y="22.706"
        fill="#1976d2"
      ></rect>
      <rect
        width="2.7"
        height="2.9"
        x="38.25"
        y="22.706"
        fill="#1976d2"
      ></rect>
      <rect
        width="2.7"
        height="2.9"
        x="31.448"
        y="19.112"
        fill="#1976d2"
      ></rect>
      <rect
        width="2.7"
        height="2.9"
        x="34.849"
        y="19.112"
        fill="#1976d2"
      ></rect>
      <rect
        width="2.7"
        height="2.9"
        x="38.25"
        y="19.112"
        fill="#1976d2"
      ></rect>
    </svg>
  ),
  yahoo: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width="100"
      height="100"
      viewBox="0 0 48 48"
      className="size-5"
    >
      <path
        fill="#673AB7"
        d="M9,5c0,0,1.4,0.3,2.5,0.3S14,5,14,5l10,17L34.1,5c0,0,1.1,0.4,2.4,0.4C37.9,5.4,39,5,39,5L26,27l0.4,16c0,0-1.4-0.4-2.4-0.4S21.5,43,21.5,43L22,27L9,5z"
      ></path>
    </svg>
  ),
  apple: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width="100"
      height="100"
      viewBox="0 0 24 24"
      className="size-5"
    >
      <path d="M 16 1 C 14.865 1 13.768969 1.4795781 13.042969 2.2675781 C 12.386969 2.9845781 11.988281 4.25725 11.988281 5.28125 C 13.160281 5.28125 14.412422 4.6809062 15.107422 3.8789062 C 15.755422 3.1279062 16 2.209 16 1 z M 8.2753906 5.5136719 C 6.1813906 5.5146719 3 7.4803281 3 12.111328 C 3 16.324328 6.7665781 21 8.8925781 21 L 8.921875 21 C 10.190875 21 10.634047 20.176969 12.373047 20.167969 C 14.112047 20.176969 14.556219 21 15.824219 21 L 15.853516 21 C 17.395516 21 19.795 18.536172 21 15.576172 C 19.693 14.924172 18.785156 13.576 18.785156 12 C 18.785156 10.461 19.652156 9.1397031 20.910156 8.4707031 C 19.823156 6.4267031 17.895703 5.5136719 16.470703 5.5136719 C 14.931703 5.5136719 13.645047 6.5546875 12.373047 6.5546875 C 11.101047 6.5546875 9.8143906 5.5136719 8.2753906 5.5136719 z M 8.2753906 7.5136719 C 8.7073906 7.5136719 9.2378281 7.7175469 9.7988281 7.9355469 C 10.546828 8.2255469 11.393047 8.5546875 12.373047 8.5546875 C 13.353047 8.5546875 14.201219 8.2255469 14.949219 7.9355469 C 15.509219 7.7185469 16.038703 7.5136719 16.470703 7.5136719 C 16.888703 7.5136719 17.539438 7.7102656 18.148438 8.1972656 C 17.281437 9.2512656 16.787109 10.587 16.787109 12 C 16.787109 13.597 17.407516 15.080687 18.478516 16.179688 C 17.487516 17.864687 16.261547 18.886 15.810547 19 C 15.658547 18.998 15.548828 18.957875 15.173828 18.796875 C 14.596828 18.548875 13.723328 18.174969 12.361328 18.167969 C 11.020328 18.174969 10.149266 18.548875 9.5722656 18.796875 C 9.2142656 18.950875 9.0976406 18.993047 8.9316406 18.998047 C 7.9416406 18.757047 5 15.437328 5 12.111328 C 5 8.6383281 7.2073906 7.5146719 8.2753906 7.5136719 z"></path>
    </svg>
  ),
  calendar: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      className="size-5"
    >
      <path d="M8 2v4" />
      <path d="M16 2v4" />
      <rect
        width="18"
        height="18"
        x="3"
        y="4"
        rx="2"
      />
      <path d="M3 10h18" />
    </svg>
  ),
}

export default ICONS
